import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './assets/fonts/Montserrat-Regular.ttf';
import './assets/fonts/Spectral-LightItalic.ttf';
import './assets/fonts/Lato-Light.ttf';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18next-config';
import { PermissionsProvider } from 'components/backoffice/PermissionsContext';
import { applyDomainSEO } from './utils/domainSeo';

const root = createRoot(document.getElementById('root'));

root.render(
  <PermissionsProvider>
    <App />
  </PermissionsProvider>
);

applyDomainSEO();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
